import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Injector, OnDestroy, OnInit, afterNextRender } from '@angular/core';
import { SiService } from '../../../system-integrator/services/si.service';

import { HoliumCardResponse,StringInverter } from '../../models/holium-card';
import { plainObject } from '../../interfaces/plain-obj';
import { holiumCardKeys } from '../../../system-integrator/constants/si.constants';
import {

  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexTitleSubtitle,
  NgApexchartsModule,
  ApexDataLabels,
  ApexMarkers,
  ApexAnnotations,
  ApexFill,
  ApexGrid,
  ApexLegend,
  ApexPlotOptions,
  ApexStroke,
  ApexTooltip,
  ApexYAxis,
} from 'ng-apexcharts';
import { CommonModule } from '@angular/common';

import { finalize, Subject, takeUntil } from 'rxjs';
import { BaseComponent } from '../../../base/components/base.component';
import { HoliumPlantType } from '../../models/enum';
import { CspNonceService } from '../../service/csp-nonce.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  title: ApexTitleSubtitle;
  fill: ApexFill;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  annotations: ApexAnnotations;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  grid: ApexGrid;
  colors?: any[];
};

@Component({
    selector: 'app-holium-dashboard',
    imports: [NgApexchartsModule, CommonModule],
    templateUrl: './holium-dashboard.component.html',
    styleUrl: './holium-dashboard.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HoliumDashboardComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  holiumPlantType = HoliumPlantType;
  HeaderKeyMap: plainObject = holiumCardKeys;
  curPlant: string = HoliumPlantType.rudrapur;
  siService: SiService = inject(SiService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly injector = inject(Injector);
  readonly destroy$ = new Subject<void>();
  cardData: HoliumCardResponse = {
    co2Saved: '',
    startTime: '',
    stopTime: '',
    operationHrs: '',
    todayYield: '',
    totalYield: '',
    outputPower: '',
    inputPower: '',
    peakOutputPower: '',
    peakOutputPowerTimestamp: '',
    treePlanted: 0,
    capacity: '',
    revenue: '',
    specificYield: '',
    CUF: '',
    PR: '',
    total: 0,
    normal: 0,
    alarm: 0,
    GTI1: '',
    GHI: '',
    ambientTemp: '',
  };
  chartData: Array<number> = [];
  chartCategories: Array<string> = [];
  fetchTime: Date = new Date();
  isLoading: boolean = false;
  ngOnInit(): void {
    this.previousPlant = HoliumPlantType.rudrapur;
    this.fetchRudrapurDetails();
    this.refreshData();

  }
  public chartOptions: Partial<ChartOptions> = {
    legend: { show: false }
  };
 
  constructor(private readonly cspNonceService: CspNonceService) {
    super();
    const nonce = this.cspNonceService.getNonce() ?? undefined;
    this.chartOptions = {
      series: [{ name: 'My-series', data: [] }],
      chart: {type: 'line',nonce:nonce},
      legend: { show: false }
    };
  }


fetchHaridwarDetails() {
  this.fetchPlantDetails(HoliumPlantType.haridwar, 'HARIDWAR');
}
 
fetchRudrapurDetails() {
  this.fetchPlantDetails(HoliumPlantType.rudrapur, 'RUDRAPUR');
}
 
fetchBaddiDetails() {
  this.fetchPlantDetails(HoliumPlantType.baddi, 'BADDI');
}

  private fetchPlantDetails(plantType: HoliumPlantType, plant: string): void {
    this.curPlant = plantType;
    this.fetchTime = new Date();

    if (this.previousPlant !== this.curPlant) {
      this.resetCard();
      this.resetChart();
      this.previousPlant = this.curPlant;
    }

    this.isLoading = true;
    this.siService.getHoliumDashboard(plant)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }),
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: (dashboardDetails) => {
          this.fillData(dashboardDetails.status.response.stringInverter);
          this.cardData = dashboardDetails.card.response;
          this.cdr.detectChanges();
        },
        error: (error: Error) => {
          this.logger.error(error.message);
        },
      });
  }


  fillData(item: Array<StringInverter>) {
    if (this.chartData.length !== 0) {
      this.chartData = []
      this.chartCategories = []
    }

    item.forEach((item: StringInverter) => {

      this.chartCategories.push(item.name);
      if (item.todayYield == '-') {
        this.chartData.push(0);
      } else {

        this.chartData.push(+item.todayYield.split(' ')[0]);
      }
    });
    this.fillChart(this.chartData, this.chartCategories)
  }

  fillChart(data: Array<number>, categories: Array<string>) {
    const nonce = this.cspNonceService.getNonce() ?? undefined;
    this.chartOptions = {
      series: [
        {
          name: 'My-series',
          data: data,
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        nonce: nonce,
      },
      title: {
        text: 'My First Angular Chart',
      },
      xaxis: {
        categories: categories,
        title: {
          text: 'Total no of Inverters',
        },
        labels: {
          datetimeUTC: false,
        },
      },
      yaxis: {

        title: {
          text: 'Today Yield (kWh)',
        },
        labels: {
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: 30,
          borderRadius: 5,
          borderRadiusApplication: 'end',
        },
      },
      tooltip: {
        x: { show: false },
        y: {
          title: {
            formatter: () => `Today Yield`,
          },
          formatter: (value: number) => `${value} kWh`,
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#ffffff'],
        },
      },
      grid: {
        show: true,
      },
      stroke: {
        width: 2,
      },
    };
  }

  resetCard() {
    this.cardData = {
      co2Saved: '',
      startTime: '',
      stopTime: '',
      operationHrs: '',
      todayYield: '',
      totalYield: '',
      outputPower: '',
      inputPower: '',
      peakOutputPower: '',
      peakOutputPowerTimestamp: '',
      treePlanted: 0,
      capacity: '',
      revenue: '',
      specificYield: '',
      CUF: '',
      PR: '',
      total: 0,
      normal: 0,
      alarm: 0,
      GTI1: '',
      GHI: '',
      ambientTemp: '',
    };
  }

  resetChart() {
    this.chartData = [];
    this.chartCategories = [];
    const nonce = this.cspNonceService.getNonce() ?? undefined;
    this.chartOptions = {
      series: [{ name: 'My-series', data: [] }],
      chart: { type: 'bar', nonce: nonce },
      legend: { show: false },
      dataLabels: { enabled: true, style: { colors: ['#ffffff'] } },
      grid: { show: true },
      stroke: { width: 2 },
    };
  }

  private previousPlant: string = ''; 
    hasChartData(): boolean {
      return !!this.chartData && this.chartData.length > 0;
  }

  refreshData() {
    const intervalId = setInterval(() => {
      switch (this.curPlant) {

        case HoliumPlantType.haridwar:

          this.fetchHaridwarDetails()
          break;
        case HoliumPlantType.rudrapur:
          this.fetchRudrapurDetails()

          break;
        case HoliumPlantType.baddi:
          this.fetchBaddiDetails()
      }
    }, 300000);
    
    this.destroy$.subscribe(() => clearInterval(intervalId));
  }
   ngAfterViewInit(): void {
  afterNextRender(() => {
    this.cdr.detectChanges();
  }, { injector: this.injector });
}

  
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
